import {Component, Input, OnInit} from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-analyticssocialstats',
  templateUrl: './analyticssocialstats.component.html',
  styleUrls: ['./analyticssocialstats.component.css']
})
export class AnalyticssocialstatsComponent implements OnInit {
@Input('analytics_score') analytics_score;
  constructor(private _location: Location) { }

  ngOnInit() {
    console.log(this.analytics_score);
  }
  goBack() {
    this._location.back()
  }
}
